module.exports = __webpack_public_path__ + "static/media/160-northern-marianas-islands.e56cefa9.svg";